import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		data: 'world'
	}
});

export default app;
